import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ChatUI from "../pages/ChatUI";

const ChatUIWrapper = () => {
  const { sessionId, tenantId, botId } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState(() => {
    const saved = localStorage.getItem("chat_messages");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    if (sessionId && sessionId !== "null" && sessionId !== "undefined") {
      localStorage.setItem("session_id", sessionId);
    } else {
      const storedSession = localStorage.getItem("session_id");
      if (storedSession) {
        navigate(`/test-assist/${tenantId}/${botId}/chat/${storedSession}`, {
          replace: true,
        });
      }
    }
  }, [sessionId, tenantId, botId, navigate]);

  useEffect(() => {
    localStorage.setItem("chat_messages", JSON.stringify(messages));
  }, [messages]);

  return <ChatUI messages={messages} setMessages={setMessages} />;
};

export default ChatUIWrapper;